// extracted by mini-css-extract-plugin
module.exports = {"header":"Body_header__1zyoM","categoryController":"Body_categoryController__2vgKR","hover":"Body_hover__2qock"};